export enum Order {
  Descending = -1,
  Ascending = 1,
}
